import { UnSaveGuard } from '@qima-labs/app/shared/guards/unsave.guard';
import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { Route } from '@angular/router';

export const TEMPLATE_ROUTES: Route[] = [
  {
    path: '',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./template.component').then(m => m.TemplateComponent),
  },
  {
    path: `${ERouters.EDIT_TEMPLATE}`,
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./shared/components/edit-template/edit-template.component').then(m => m.EditTemplateComponent),
  },
  {
    path: `${ERouters.EDIT_TEMPLATE}/:id`,
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./shared/components/edit-template/edit-template.component').then(m => m.EditTemplateComponent),
  },
];
